/** The property's own name, and what a clause falls back to unnamed. */
export const PREVIOUS_APPROVAL_LABEL = 'Previous approval'

/**
 * The bolded review-step name in a condition's preview. One per clause, so a
 * test scopes it to the clause it is asserting on.
 *
 * Kept in a leaf module with no component imports: a test reading it must not
 * pull the component bundle into the runner.
 */
export const REVIEW_NAME_TEST_ID =
  'automations.condition.previousApproval.reviewName'
